\:host
    width: 100%
    display: flex
    flex-direction: row
    align-items: flex-end
    color: rgb($globalSettingsFontTertiary)

.VoucherContainer
    height: unset
    width: 100%
    box-sizing: border-box
    display: flex
    flex-direction: row
    align-items: flex-end

.VoucherContainerWithInput
    height: 50px

.AddText
    text-decoration: underline
    cursor: pointer
    white-space: nowrap
    &:hover
        color: rgb($globalSettingsFontSecondary)

.DoneContainer
    display: flex
    flex-direction: column
    .DoneContainer
        font-weight: 800
        letter-spacing: 0.25px
    .VoucherCodeContainer
        height: 30px
        display: flex
        flex-direction: row
        align-items: flex-end
        color: rgb($globalSettingsFontPrimary)
        gap: 5px

.InputContainer
    position: relative
    width: 100%
    height: 40px
    border: 1px rgb($globalSettingsStrokeSecondary) solid
    border-radius: $globalButtonRounding
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    margin: 0
    padding: 0 0 0 10px
    box-sizing: border-box
    box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    &:hover
        border-color: rgb($globalSettingsStrokePrimary)
    &:focus-within
        outline: none
        border-color: rgb($globalSettingsStrokePrimary)
        stroke: rgb($globalSettingsFontTertiary)
    input
        margin-right: 10px
        background: rgb($globalSettingsBackgroundPrimary)
        outline: none
        border: none
        width: 100%
        color: rgb($globalSettingsFontSecondary)
        font-size: 14px
        &:hover
            color: rgb($globalSettingsFontPrimary)
        &:focus
            color: rgb($globalSettingsFontPrimary)
    .InputLabel
        position: absolute
        font-size: 12px
        top: -1em
        left: 0
        height: 1em
        line-height: 1em
        z-index: 1
        display: inline-block
        vertical-align: text-top
        padding: 0 2px 0 0
        font-weight: 700
        pointer-events: none
        color: rgb($globalSettingsFontTertiary)
        white-space: nowrap
        user-select: none
        border-bottom: 1px solid rgb($globalSettingsBackgroundPrimary)
        box-sizing: border-box
        text-overflow: ellipsis

    .ActionContainer
        position: relative
        height: 40px
        margin: -1px
        padding: 10px
        box-sizing: border-box
        border: 2px rgb($globalSettingsFontPrimary) solid
        border-radius: $globalButtonRounding
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        flex-shrink: 0
        font-weight: 700
        font-size: 14px
        color: rgb($globalSettingsFontPrimary)

.RemoveContainer
    position: relative
    margin-left: 5px
    box-sizing: border-box
    display: flex
    flex-direction: row
    justify-content: flex-end
    cursor: pointer
    &:active
        margin-bottom: -1px

.Clickable
    cursor: pointer
    &:active
        padding-top: 2px

::placeholder
    color: rgb($globalSettingsFontTertiary)
    opacity: 1

::-ms-input-placeholder
    color: rgb($globalSettingsFontTertiary)
